require('babel-polyfill');
import Vue from 'vue';

Vue.component('map-how-to-go-component', require('../component/MapHowToGoComponent'));

const app = new Vue({
    el: '#app',
});



// WEBPACK FOOTER //
// ./themes/default/assets/src/js/map.js